import type { TypographyProps } from '../types/typography.types';
import { cn } from '@utils';
import React from 'react';

const OverlineTypography = React.forwardRef<HTMLParagraphElement, TypographyProps>(
	({ className, children, truncate = true, ...props }, ref) => (
		<p
			ref={ref}
			className={cn(className, `scroll-m-20 text-2xs font-normal ${truncate ? 'truncate' : ''}`)}
			data-aid="overline-typography"
			{...props}
		>
			{children}
		</p>
	)
);

OverlineTypography.displayName = 'OverlineTypography';

export default OverlineTypography;
